import React,{useEffect} from 'react'
import './Slider.css'
import image1 from '../../assets/images/image1.jpg'
import image2 from '../../assets/images/image2.png'
import image3 from '../../assets/images/image3.jpg'
import aos from 'aos';
import 'aos/dist/aos.css'
import { Link } from 'react-router-dom'

const Slider = () => {
    useEffect(()=>{
        aos.init({duration:1000});
      },[]);
    return (
        <div id="carouselExampleInterval" className="carousel slide slider-container mb-3" data-bs-ride="carousel">
            <div className="carousel-inner slider-inner-container">
                <div className="carousel-item active" data-bs-interval="10000">
                    <img src={image1} className="img-fluid" alt="..." />
                    <div className='slide-content'>
                        <p data-aos="zoom-in">Research, Innovations, Health Services and more under one roof</p>
                        <h1 data-aos="zoom-in">A BETTER WAY FOR HEALTHCARE</h1>
                        <Link to='/about-us'><button data-aos="zoom-in" className='main-btn'>About us</button></Link>
                    </div>
                </div>
                <div className="carousel-item" data-bs-interval="2000">
                    <img src={image2} className="img-fluid" alt="..." />
                    <div className='slide-content'>
                    <p>Research, Innovations, Health Services and more under one roof</p>
                        <h1>A BETTER WAY FOR HEALTHCARE</h1>
                        <Link to='/about-us'><button data-aos="zoom-in" className='main-btn'>About us</button></Link>
                    </div>
                </div>
                <div className="carousel-item">
                    <img src={image3} className="img-fluid" alt="..." />
                        <div className='slide-content'>
                        <p>Research, Innovations, Health Services and more under one roof</p>
                        <h1>A BETTER WAY FOR HEALTHCARE</h1>
                        <Link to='/about-us'><button data-aos="zoom-in" className='main-btn'>About us</button></Link>
                    </div>
                </div>
            </div>

            <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleInterval" data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Previous</span>
            </button>
            <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleInterval" data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
            </button>
        </div>

    )
}

export default Slider
